export const BUILD_VERSION = '1775584958';
